import styled, { css } from 'styled-components';

const GenericCardBox = css`
  font-size: 12px;
  background: ${({ theme, type }) =>
    type === 'alternative' ? theme.secondaryColor : theme.onPrimaryColor};
  border: 2px solid ${({ theme }) => theme.surfaceColor};
  border-radius: 5px;
  color: ${({ theme, type }) =>
    type === 'alternative' ? theme.onSecondaryColor : 'inherit'};
  position: relative;
  animation: ${({ theme, isCurrent }) => (!isCurrent ? theme.animation : '')};
`;

export const CardBox = styled.section`
  ${GenericCardBox}
`;

export const HistoryCardBox = styled.section`
  ${GenericCardBox}
  padding: 16px;
  min-width: 264px;

  .history-card &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid ${({ theme }) => theme.surfaceColor};
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    left: -17px;
    top: 24px;
  }

  .history-card &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid
      ${({ theme, type }) =>
        type === 'alternative' ? theme.secondaryColor : theme.onPrimaryColor};
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    left: -14px;
    top: 24px;
  }
`;

export const CardClear = styled.section`
  font-size: 12px;
  background: transparent;
  color: ${({ theme, type }) =>
    type === 'alternative' ? theme.onSecondaryColor : 'inherit'};
  position: relative;
  margin: 10px;
  text-align: center;

  p {
    font-size: 14px;
    word-break: break-word;
  }
`;

export const TitleBox = styled.div`
  background: ${({ theme, isSuccess }) =>
    isSuccess ? theme.successColor : theme.secondaryColor};
  color: ${({ theme }) => theme.onSecondaryColor};
  display: flex;
  padding: 10px 20px;

  div {
    display: flex;
    align-self: center;

    h2 {
      font-size: 15px;
      word-break: break-word;
    }
  }
`;

export const ContentBox = styled.div`
  h3 {
    margin: 25px 25px 0 25px;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    word-break: break-word;
  }
`;

export const MarkdownStyles = css`
  p,
  ul,
  ol {
    word-break: break-word;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    line-height: 21px;

    li {
      margin-bottom: 14px;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    word-break: break-word;
    font-style: normal;
    font-weight: bold;
    line-height: 28px;
  }
  h4 {
    margin-bottom: 14px;
    font-size: 16px;
  }
  h3 {
    margin-bottom: 16px;
    font-size: 16px;
  }
  h2 {
    margin-bottom: 16px;
    font-size: 18px;
  }
  h1 {
    margin-bottom: 20px;
    font-size: 20px;
  }

  img {
    width: 100%;
    margin: 20px auto 10px;
    image-rendering: -webkit-optimize-contrast;
  }
`;

export const MarkdownContainer = styled.div`
  width: 100%;
  ${MarkdownStyles}
`;
